export default __webpack_public_path__ + "static/media/Personaje-Banner-4.11124bb9.png";